import React, { ReactNode } from 'react'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

export type DynamicObject = Record<string, unknown>

interface DynamicDataRendererProps {
  data: DynamicObject | DynamicObject[]
}

export const DynamicDataRenderer: React.FC<DynamicDataRendererProps> = ({
  data,
}) => {
  const isArray = Array.isArray(data)

  if (!isArray) {
    // Render list for single object
    return (
      <ul className="space-y-2">
        {Object.entries(data ?? {}).map(([key, value]) => (
          <li
            key={key}
            className="grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)] gap-4"
          >
            <span className="break-words font-medium">{key}:</span>
            <span className="break-words text-right">
              {JSON.stringify(value)}
            </span>
          </li>
        ))}
      </ul>
    )
  }

  // Render table for array of objects
  if (data.length === 0) {
    return <p>No data to display</p>
  }

  const columns = Array.from(new Set(data.flatMap((obj) => Object.keys(obj))))

  return (
    <Table className="min-w-max">
      <TableHeader>
        <TableRow>
          {columns.map((column) => (
            <TableHead key={column} className="whitespace-nowrap">
              {column}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            {columns.map((column) => (
              <TableCell
                key={column}
                className="min-w-32 max-w-md break-words p-2"
              >
                {Array.isArray(item[column]) || typeof item[column] == 'object'
                  ? JSON.stringify(item[column])
                  : (item[column] as ReactNode)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
